import type { Validation } from "@/lib/validation"
import { validationStructuresCollection } from "@/lib/validation/structures"

export const isValidationStructure = (
  subject: unknown
): subject is Validation.StructureOption => {
  return validationStructuresCollection[subject as Validation.StructureOption]
}
